import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a4f92b9b: FaireBrandEntity = {
  token: "b_a4f92b9b",
  type: "brand",
  name: "AQUARIUS, GAMAGO, ICUP, & ROCK SAWS by NMR Brands",
  avatarUrl:
    "https://cdn.faire.com/fastly/0c56b070069b7f57a8b568949f2132cd195896331034c86b3ca97bb7f63d024f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c26157a7ec11153504d835cd5cf47e3282534af15879009be07622ebd935ad59.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0c56b070069b7f57a8b568949f2132cd195896331034c86b3ca97bb7f63d024f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c26157a7ec11153504d835cd5cf47e3282534af15879009be07622ebd935ad59.jpeg",
  location: "Valencia, CA, USA",
  minimumOrderDollars: 2500,
  rating: 4.8,
  reviewCount: 168,
  isTopShop: true,
  isInsider: true,
  description:
    "Since its inception in 1999, NMR Brands has become a global provider of licensed and branded Games, Puzzles, Playing Cards, and Lifestyle Products. We market our products under our trademarked brands AQUARIUS, GAMAGO, GREAT STUFF NOVELTIES, ICUP and ROCK SAWS.\n\n- AQUARIUS licensed products and platform games are both a reflection of today’s favorites and a nod to the past and are designed to entertain young and old alike.\n\n- GAMAGO has been designing original and fun stuff in San Francisco since 2001 and is known for its creative and unique take on lifestyle, baby, and kitchen products.\n\n- GREAT STUFF NOVELTIES (GSN) brings you a wide assortment of print-on-demand mugs, magnets, and buttons in both licensed and non-licensed varieties. Colorful and entertaining, these products will catch your eye and tickle your funny bone.\n\n- Established in 1998, ICUP, home of the “Moose Mug”, makes fun & quirky novelties, decorative housewares, seasonal gifts, and kitchen accessories. Their items are intended to surprise, inspire, and make you smile.\n\n- Established in 2020, ROCK SAWS transforms classic album cover art into amazing jigsaw puzzles. Printed on high-quality blue board, these puzzles are a must for people with an emotional connection to classic album covers and music.",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:36:08.433Z",
    importedBy: "entity-db-cli",
  },
};
